export const taskStatus = {
  DRAW: "DRAW",
  TEMPLATING: "TEMPLATING",
  CLOSED: "CLOSED",
  REVIEW: "REVIEW",
  CANCELED: "CANCELED",
  FULFILLED: "FULFILLED",
  REFINEMENT: "REFINEMENT",
};

export const orderStatus = {
  ORDER_CREATED: "ORDER_CREATED",
  IN_PROGRESS: "IN_PROGRESS",
  READY_FOR_FULFILL: "READY_FOR_FULFILL",
  WAITING_FOR_FULFILL: "WAITING_FOR_FULFILL",
  IN_FULFILL: "IN_FULFILL",
  FULFILLED: "FULFILLED",
  FULFILL_ERROR: "FULFILL_ERROR",
  CLOSED: "CLOSED",
};

export const permissions = {
  TASK_IMPORTING: "TASK_IMPORTING",
  TASK_DRAWING: "TASK_DRAWING",
  TASK_TEMPLATING: "TASK_TEMPLATING",
  TASK_REFINEMENT: "TASK_REFINEMENT",
  TASK_REVIEW: "TASK_REVIEW",
  ADMIN: "ADMIN",
  MANAGER: "MANAGER",
  TASKMARKET: "TASKMARKET",
  MANAGE_RATINGS: "MANAGE_RATINGS",
  FULFILL_ORDERS: "FULFILL_ORDERS",
  MANAGE_ORDERS: "MANAGE_ORDERS",
  MANAGE_TASKS: "MANAGE_TASKS",
  READ_ALL_USERS: "READ_ALL_USERS",
  WRITE_ALL_USERS: "WRITE_ALL_USERS",
  SETTINGS: "SETTINGS",
  STATISTICS: "STATISTICS",
  SEND_MAILS: "SEND_MAILS",
};

export const taskStatusPermissionsMapping = {
  [permissions.TASK_DRAWING]: taskStatus.DRAW,
  [permissions.TASK_TEMPLATING]: taskStatus.TEMPLATING,
  [permissions.TASK_REFINEMENT]: taskStatus.REFINEMENT,
  [permissions.MANAGER]: taskStatus.REVIEW,
};

export const dbCollection = {
  TASKS: "tasks",
  USERS: "users",
  MAIL: "mail",
  CUSTOMERS: "customers",
};

export const countryCodes = {
  DE: "DE",
  ES: "ES",
  AT: "AT",
  PL: "PL",
  LU: "LU",
  FR: "FR",
  BE: "BE",
  US: "US",
  CA: "CA",
  NL: "NL",
};

export const domainByShopId = {
  AQ: {
    DE: "Artquarell.com",
    ES: "Artcuarela.es",
    PL: "Artkwarela.pl",
    FR: "Artquarelle.fr",
  },
  TM: {
    DE: "TierBeiMir.com",
  },
  OH: {
    US: "ohmy.art",
    CA: "ohmy.art",
  },
};

export const supportNameByShopId = {
  AQ: {
    DE: "Anna",
    ES: "Lisa",
    PL: "Lisa",
    FR: "Anna",
  },
  TM: {
    DE: "Lisa",
  },
  OH: {
    US: "Anna",
    CA: "Anna",
  },
};

export const shopifyNameByShopId = {
  AQ: {
    DE: "artquarell",
    ES: "artcuarela",
    PL: "6fa17e-4",
    FR: "3c781a-ad",
  },
  TM: {
    DE: "tierbeimir",
  },
  OH: {
    US: "p1v9pv-ht",
    CA: "p1v9pv-ht",
  },
};

export const shopAndCountryMap = Object.keys(shopifyNameByShopId).reduce(
  (acc, key) => {
    acc[key] = Object.keys(shopifyNameByShopId[key]);
    return acc;
  },
  {}
);

export const allowedTemplatePatternByShopAndCountry = {
  AQ: {
    DE: /^[a-zA-Z\u00E4\u00FCa-åa-ö-w 0-9 -?!&$_.:àáéèñńëúùû]*$/,
    AT: /^[a-zA-Z\u00E4\u00FCa-åa-ö-w 0-9 -?!&$_.:àáéèñńëúùû]*$/,
    ES: /^[a-zA-Z\u00E4\u00FCa-åa-ö-w 0-9 -?!&$_.:àáéèñńëúùû]*$/,
    FR: /^[a-zA-Z\u00E4\u00FCa-åa-ö-w 0-9 -?!&$_.:àáéèñńëúùû]*$/,
    PL: /^[\s\S]*$/,
  },
  OH: {
    US: /^[a-zA-Z\u00E4\u00FCa-åa-ö-w 0-9 -?!&$_.:àáéèñńëúùû]*$/,
  },
};

export const orderFilterCategories = {
  ALL: 0,
  DELAYED_FULFILL: 1,
  DELAYED_SHIPMENT: 2,
};

export const editStyles = [
  {
    text: "Upscale (0)",
    value: "1",
  },
  {
    text: "Person (1)",
    value: "1",
  },
  {
    text: "Car (2)",
    value: "2",
  },
  {
    text: "Optimised Person/Animal (3)",
    value: "3",
  },
  {
    text: "Animal (4)",
    value: "4",
  },
  {
    text: "Drawing (5)",
    value: "5",
  },
  {
    text: "Detailed Vector (6)",
    value: "6",
  },
];
